import React from "react";
import { Button } from "@timeedit/ui-components";

type CopyProps = {
  buttonText: string;
  clipboardText: () => string;
};

export function CopyButton({
  buttonText,
  clipboardText,
}: CopyProps): React.JSX.Element {
  return (
    <Button onClick={onCopy} size="small">
      {buttonText}
    </Button>
  );

  function onCopy(): void {
    navigator.clipboard.writeText(clipboardText());
  }
}
